import { render, staticRenderFns } from "./HandoutDownloadConfirmation.vue?vue&type=template&id=0da7c846&"
import script from "./HandoutDownloadConfirmation.vue?vue&type=script&lang=js&"
export * from "./HandoutDownloadConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./HandoutDownloadConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports